import { Children, isValidElement } from 'react'
import { useInputTextProps } from '../../hooks'
import { InputTextButton } from '../input-button'
import * as Comp from './input-actions.styles'

export const InputTextActions = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { size, isActive, inputValue, id, hasError, disabled, readonly } =
    useInputTextProps()
  const isFilled = inputValue.length > 0

  const hasCleanerButton = Children.toArray(children).some(child => {
    return isValidElement(child) && child.type === InputTextButton
  })

  return (
    <Comp.Actions
      size={size}
      role="form"
      isActive={isActive}
      isFilled={isFilled}
      hasCleanerButton={hasCleanerButton}
      aria-label={id}
      hasError={hasError}
      disabled={disabled}
      readonly={readonly}
    >
      {children}
    </Comp.Actions>
  )
}
